import styled from 'styled-components'

export const SearchInputContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  padding: 5px 10px;
  border-radius: 8px;
  border: solid 1px #2b2b2b;
`

export const SearchInputText = styled.input`
  font-size: 16px;
  color: #2b2b2b;
  border: none;
`
